<template>
  <b-navbar
    type="light"
    toggleable="xl"
    fixed="top"
    class="header-area"
    :class="{ 'is-sticky': scrolled }"
  >
    <NavBarHeader />
  </b-navbar>
</template>

<script>
import NavBarHeader from "@/components/NavBarHeader";
export default {
  name: "HeaderElement",
  components: { NavBarHeader },
  data() {
    return {
      load: false,
      limitPosition: 200,
      scrolled: false,
      lastPosition: 500,
    };
  },
  methods: {
    // sticky menu script
    handleScroll() {
      if (
        this.lastPosition < window.scrollY &&
        this.limitPosition < window.scrollY
      ) {
        this.scrolled = true;
        // move up!
      }
      if (this.lastPosition > window.scrollY) {
        this.scrolled = true;
        // move down
      }
      this.lastPosition = window.scrollY;
      this.scrolled = window.scrollY > 50;
    },

    // offcanvas searchbox
    toggleClass(addRemoveClass, className) {
      const el = document.querySelector("#search-overlay");
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    // offcanvas searchbox
    mobiletoggleClass(addRemoveClass, className) {
      const el = document.querySelector("#offcanvas-menu");
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss">
.mobile-menu-bar {
  color: #6d70a6;
  font-size: 25px;
  border: 1px solid#6d70a6;
  padding: 8px 10px 10px;
  line-height: 1;
  height: 42px;
  margin-top: 6px;
  border-radius: 4px;
}

.element-menu {
  [aria-expanded="false"] {
    background-color: transparent;
  }
  .dropdown-item {
    font-size: 14px;
    &:hover {
      color: #5945e6;
      background-color: transparent;
    }
  }
  .dropdown-menu {
    border: none;
    border-bottom: 3px solid #5945e6;
    margin-top: -2px;
  }
}
.mega-menu {
  .dropdown-menu {
    min-width: 100%;
  }
  .mega-submenu {
    width: 33.33%;
    float: left;
    .nav-link {
      padding: 20px 10px !important;
      .mega-title {
        .dropdown-item {
          font-weight: 500;
          color: #000;
        }
      }
    }
  }
}
</style>
